import { Fragment, useEffect } from "react";
import { Routes, Route, Outlet, useLocation, useParams, Navigate } from "react-router-dom";
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-quill/dist/quill.snow.css';
import useAxios from "axios-hooks";
import { RequireAuth, useIsAuthenticated } from 'react-auth-kit'
import Home from "./Step0_Home";
import Email from "./Step1_Email";
import Details from "./Step2_Details";
import Content from "./Step3_Content";
import Promote from "./Step4_Promote";
import Checkout from "./Step5_Checkout";
import BrandContext from "./BrandContext";
import Channel from "./Step3a_Channel";
import Submitted from "./Step3b_Submitted";
import Pitch from "./Step3_Pitch";
import MeetingRequest from "./MeetingRequest";
import Login from "./Login";
import EditPR from "./EditPR";

function App() {
  const params = useParams();
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const [{ data: theme, loading, error }, refetch] = useAxios({
    method: 'get',
    url: '/pr/brand',
    params: {
      accountId: params.accountId,
      brandId: params.brandId
    },
  });

  useEffect(() => {
    if (theme?.status === 'inactive') window.location.replace('http://www.swiftrev.com')
  }, [theme]);

  const PrivateRoute = ({ children, loginPath }) => {
    const isAuthenticated = useIsAuthenticated();
    const location = useLocation();

    if (isAuthenticated()) {
      return children;
    }

    return <Navigate
      to={loginPath}
      state={{ from: location }}
      replace
    />;
  };

  return (
    <Fragment>
      <style type="text/css">
        {`
          .btn-swiftrev {
            background-color: ${theme?.marketing?.brandColor};
            color: white;
          }
          .btn-swiftrev:hover {
            border-color: ${theme?.marketing?.brandColor};
            background-color: white;
            color: black;
          }
          .btn-outline-swiftrev {
            border-color: ${theme?.marketing?.brandColor};
            color: ${theme?.marketing?.brandColor};
          }
          .btn-outline-swiftrev:hover {
            border-color: ${theme?.marketing?.brandColor};
            background-color: ${theme?.marketing?.brandColor};
            color: white;
          }
          .bg-swiftrev {
            background-color: ${theme?.marketing?.brandColor};
            color: white;
          }
          .text-swiftrev {
            color: ${theme?.marketing?.brandColor};
          }
          .progress-swiftrev .progress-bar {
            background-color: ${theme?.marketing?.brandColor};
            color: white;
          }
          .check-swiftrev .form-check-input:checked {
            background-color: ${theme?.marketing?.brandColor};
            color: white;
          }
          .check-swiftrev .form-check-input {
            height: 24px;
            width: 24px;
            margin-top: .5em;
            margin-left: -2em;
          }
          .check-swiftrev .form-check-label {
            font-size: 24px;
            font-weight: bold;
          }
          .swiftrev-alert {
            box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);
            background-color: ${theme?.marketing?.brandColor};
            color: white;
            border-radius: 5px;
          }
          .swiftrev-ql .ql-editor p {
            margin-block-end: 24px;
            line-height: 24px;
            font-size: 16px;
            font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
          }
        `}
      </style>
      <BrandContext.Provider value={theme}>
        <Routes>
          <Route index element={<Navigate to="pr" />} />
          <Route path="/meeting-request" element={<MeetingRequest />} />
          <Route path="/pr" element={<Outlet />} >
            <Route index element={<Home />} />
            <Route path="email" element={<Email />} />
            <Route path=":prId/*" element={<Outlet />}>
              <Route path='login' element={<Login />} />
              <Route path="details" element={<Details />} />
              <Route path="content" element={<Content />} />
              <Route path="pitch" element={<Pitch />} />
              <Route path="channel" element={<Channel />} />
              <Route path="submitted" element={<Submitted />} />
              <Route path="promote" element={<Promote />} />
              <Route path="checkout" element={<Checkout />} />
              <Route path={'edit'} element={
                <PrivateRoute loginPath={'../login'}>
                  <EditPR />
                </PrivateRoute>
              } />
            </Route>
          </Route>
        </Routes>
      </BrandContext.Provider>
    </Fragment>
  );
}

export default App;
